
        import { configureAmplify } from './amplify-config.js';
        
        // Configure Amplify immediately
        configureAmplify();
        
        // Then load auth and data-sync modules, and run auth init after both ready
        const [authMod] = await Promise.all([
            import('./auth.js'),
            import('./data-sync.js')
        ]);
        
        // Run auth initialization now that Amplify is configured and DOM is ready
        await authMod.default.init();
    